export default class APIError extends Error {
  message: string

  constructor(message: string) {
    super(message)

    this.message = message.replaceAll(',', '\n')
  }
}
